<template>
  <!-- <div>123456789</div> -->
  <div v-html="html"></div>
</template>

<script>
import api from '../../api/index'
export default {
//   props: {
//     amountVal: {
//       type: String,
//       default: function () {
//         return {}
//       }
//     }
//   },
  data () {
    return {
      html: '',
      amountItem: {
        amountVal: '',
        token: '',
        phNum: '',
        platform: ''
      },
      amountVal: '',
      token: '',
      phNum: '',
      platform: ''
    }
  },
  created () {
    this.amountItem = JSON.parse(this.$route.query.amountItem)
    this.amountVal = this.amountItem.amountVal
    this.token = this.amountItem.token
    this.phNum = this.amountItem.phNum
    this.platform = this.amountItem.platform || 'android'
    if (this.$route.query.token || this.$route.query.phNum) {
      this.$router.replace('/h5RechargePageA-detail?amountVal=' + this.amountVal)
    }
  },
  mounted () {
    // if (this.platform === 'android') {
    if (this.platform === 'android') {
      this.fetchVideoPay()
    } else {
      this.appTypeWarning()
    }
  },
  methods: {
    fetchVideoPay () {
      console.log('amountItem', this.$route.query)
      console.log('amountVal & token & phNum', this.amountVal, this.token, this.phNum)
      if (this.token || this.phNum) {
        const pusher = {
          total: Number(this.amountVal)
        }
        if (this.token) { pusher.token = this.token }
        if (this.phNum) { pusher.phone = this.phNum }
        api.payTest(pusher).then(res => {
          this.html = res.data
          this.$nextTick(() => {
            document.forms[0].submit()
          })
        })
      }
    },
    appTypeWarning () {
      this.showPay = false
      this.$toast.text('请在电脑端使用同一账号充值')
    }
  }
}
</script>
